import { get } from 'lodash';
import React from 'react';
import { getLocalstorageToken } from '../../../../../../../context/AuthHelper';
import PersonalKostenMA, { getFormStrucPersonalKostenMA } from './PersonalKostenMA';

// import Schemas
import MittelAbrufSchema from '../../../../../../../lib/paths/mittelabruf_FULL_Paths.json';
const MA_P = MittelAbrufSchema.attributes;

export const GetPersonalKostenMA = (application: any, readOnly: boolean) => {
	const OrgaStruc = [
		{
			label: get(
				application,
				MA_P.Foerderantrag.schema.attributes.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path,
				`Antragsteller`
			),
			content: <PersonalKostenMA kostentraeger='Antragsteller' unternehmenId={get(getLocalstorageToken(), 'organisationId')} />,
			formStruc: getFormStrucPersonalKostenMA(application, 'Antragsteller', get(getLocalstorageToken(), 'organisationId'), readOnly),
		},
	];
	const PartnerStruc = get(application, MA_P.Foerderantrag.schema.attributes.Verbundpartner.path, []).map((ele: any, i: number) => {
		return {
			label: get(
				ele,
				MA_P.Foerderantrag.schema.attributes.Verbundpartner.schema.attributes.Verbundpartner.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path.slice(
					MA_P.Foerderantrag.schema.attributes.Verbundpartner.path.length + 1
				),
				`Verbundpartner ${i + 1}`
			),
			content: <PersonalKostenMA kostentraeger='Verbundpartner' unternehmenId={get(ele, 'Verbundpartner.id')} />,
			formStruc: getFormStrucPersonalKostenMA(application, 'Verbundpartner', get(ele, 'Verbundpartner.id'), readOnly),
		};
	});

	return [...OrgaStruc, ...PartnerStruc];
};
